import React from 'react';
import { Code, Layers, Package, Globe } from 'lucide-react';
import TechnologyChip from './TechnologyChip';
const TechnologyStackResults = ({ results }) => {
  const isTrial = false;
  console.log('TechnologyStackResults received:', results);
  
  // Parse and group technologies by category
  const groupedTech = results.reduce((acc, result) => {
    try {
      // Technology data is in result.data, not result.value
      const tech = result.data || {};
      const categories = tech.categories || ['Other'];
      
      categories.forEach(category => {
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(tech);
      });
    } catch (e) {
      console.error('Failed to parse technology data:', e, result);
    }
    
    return acc;
  }, {});
  
  console.log('Grouped technologies:', groupedTech);

  const getCategoryIcon = (category) => {
    const iconMap = {
      'CMS': Layers,
      'JavaScript frameworks': Code,
      'Programming languages': Code,
      'Web servers': Globe,
      'CDN': Globe,
      'Analytics': Package,
    };
    return iconMap[category] || Package;
  };

  const getCategoryColor = (category) => {
    const colorMap = {
      'CMS': 'text-purple-600',
      'JavaScript frameworks': 'text-blue-600',
      'Programming languages': 'text-green-600',
      'Web servers': 'text-cyan-600',
      'CDN': 'text-orange-600',
      'Analytics': 'text-pink-600',
    };
    return colorMap[category] || 'text-slate-500';
  };

  const allEntries = Object.entries(groupedTech);
  const visibleEntries = isTrial && allEntries.length > 1 ? allEntries.slice(0, 1) : allEntries;
  const hiddenEntries = isTrial && allEntries.length > 1 ? allEntries.slice(1) : [];

  const renderCategoryRow = ([category, technologies]) => {
    const Icon = getCategoryIcon(category);
    const color = getCategoryColor(category);
    return (
      <div key={category} className="flex items-start space-x-3 pb-4 border-b border-slate-200 last:border-0 last:pb-0">
        <div className="flex items-center space-x-2 min-w-[200px] pt-1">
          <Icon className={`w-4 h-4 ${color}`} />
          <h3 className="text-sm font-bold text-slate-500">{category}</h3>
          <span className="text-xs text-gray-600">({technologies.length})</span>
        </div>
        <div className="flex flex-wrap gap-2 flex-1">
          {technologies.map((tech, idx) => (
            <TechnologyChip key={idx} tech={tech} Icon={Icon} trialMode={isTrial} />
          ))}
        </div>
      </div>
    );
  };

  const hiddenTechCount = hiddenEntries.reduce((sum, [, techs]) => sum + techs.length, 0);

  return (
    <div className="space-y-4">
      {visibleEntries.map(renderCategoryRow)}
      {hiddenEntries.length > 0 && (
        
          <div className="space-y-4">
            {hiddenEntries.map(renderCategoryRow)}
          </div>
        
      )}
    </div>
  );
};

export default TechnologyStackResults;
